
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"#8990A3FF","d":"M28 0H4C1.79087 0 0 1.79075 0 4v16c0 2.2091 1.79087 4 4 4h24c2.2092 0 4-1.7909 4-4V4c0-2.20925-1.7908-4-4-4zM4 2h24c1.1028 0 2 .89719 2 2v2.2505l-12.1992 9.1499c-1.0625.7949-2.539.7949-3.6015 0L2 6.2505V4c0-1.10281.89719-2 2-2zm26 18c0 1.1028-.8972 2-2 2H4c-1.10281 0-2-.8972-2-2V8.74963L13 17c.8828.6631 1.9414.9941 3 .9941s2.1172-.331 3-.9941l11-8.25037V20z"}})])
          )
        }
      }
    